import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const NavigationIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      viewBox="0 0 24.211 20"
      fill={color}
    >
      <rect width="24.211" height="2.1" rx="1.05" />
      <rect width="24.211" height="2.1" y="8.95" rx="1.05" />
      <rect width="24.211" height="2.1" y="17.9" rx="1.05" />
    </SVG>
  );
};
